import styled from '@emotion/styled';
import { RichDropdownMenu } from '@liveoptics/react-ui';
import { useRequest } from 'ahooks';
import React, { Dispatch, FormEvent, SetStateAction, useCallback, useEffect } from 'react';
import { getTheaters } from '../../../api/api';
import { TheaterTypeIndexMapper } from '../../../enums';

export interface TheatersDropDownMenuProps {
  defaultValue?: string;
  setLoadingCallback?: Dispatch<SetStateAction<boolean>>;
  onChange?: (value: string) => void;
}

const StyledDropDownMenu = styled(RichDropdownMenu)`
  width: 100% !important;
`;

export const TheatersDropDownMenu = (props: TheatersDropDownMenuProps) => {
  const request = useRequest(getTheaters, {
    manual: true,
    debounceWait: 500,
    cacheKey: 'theaters-cache',
    staleTime: 60 * 60 * 1000,
  });

  useEffect(() => {
    if (!request.data) request.run();
  }, []);

  if (props.setLoadingCallback) props.setLoadingCallback(request.loading);

  const handleChange = useCallback(
    (option: FormEvent<HTMLDivElement> & { value: string; label: string }) => {
      if (props.onChange) {
        props.onChange(option.value);
      }
    },
    [props]
  );

  const renderOptions = () => {
    if (request.loading) return [];
    if (request.data)
      return Object.entries(request.data).map(([k, v]) => ({
        value: TheaterTypeIndexMapper[k],
        label: v,
      }));
    return [];
  };

  return (
    <StyledDropDownMenu
      placeholder={'Loading...'}
      disabled={request.loading || !request.data}
      onChange={handleChange}
      options={renderOptions()}
      value={props.defaultValue}
    />
  );
};
